import { doAjax } from 'newJs/utils';
import { trimSlashes } from 'tbSrc/js/utils';

export default (mapiHost, userEmail, version = 'v1') => {
    const baseUrl = `https://${trimSlashes(mapiHost)}`;
    const mapiUrl = `${baseUrl}/${version === 'v1' ? '' : 'v2/'}mailbox/`;
    const mapiBaseUrl = `${mapiUrl}${encodeURIComponent(userEmail)}/folders`;

    // Refefence: https://git.co.inbox.lv/service/mapi/blob/master/conf/routes
    const endPoints = (version) => version === 'v1'
        // Version 1
        ? {
            batch() {
                return `${mapiUrl}batch`;
            },
            getFoldersList(invalidateCache = false) {
                return `${mapiBaseUrl}?showOutbox=1${invalidateCache ? '&invalidateCache=true' : ''}`;
            },
            send() {
                return `${baseUrl}/message/send`;
            },
            appendMessage(folder) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages`;
            },
            messages(folder) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages`;
            },
            msgMoveTo(fromFolder) {
                return `${mapiBaseUrl}/${encodeURIComponent(fromFolder)}/messages/_move`;
            },
            // PUT /mailbox/:email/folders/:folder
            folderCreate(folder) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}`;
            },
            // DELETE /mailbox/:email/folders/:folder
            folderDelete(folder) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}`;
            },
            /* Rename folder */
            // PUT http://mapi.indev.lv/mailbox/testdev4@inbox.lv/folders/[old folder urlencoded]
            // Body: {"name": "INBOX/new folder"}
            folderRename(oldFolder) {
                return `${mapiBaseUrl}/${encodeURIComponent(oldFolder)}`;
            },
            quota() {
                return `${mapiUrl}${userEmail}/info`;
            }
        }
        // Version 2
        : {
            // POST /v2/mailbox/:email/folders/:folder/messages/:msguid/blockSender
            blockSender(folder, msguid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/blockSender`;
            },
            contactsSave() {
                return `${baseUrl}/contacts/v2/vcards/url`;
            },
            /* Purge folder (delete all messages in it) */
            // POST /v2/mailbox/:email/folders/:folder/purge
            folderPurge(folder) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/purge`;
            },
            // GET /v2/mailbox/:email/folders/:folder/messages/:msguid/thumb/:partid
            getAttachThumb(folder, msguid, partid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/thumb/${partid}`;
            },
            // GET /v2/mailbox/:email/folders/:folder/messages/:msguid/zip
            getAllAsZip(folder, msguid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/zip`;
            },
            // GET /v2/mailbox/:email/folders
            getFoldersList(invalidateCache = false) {
                return `${mapiBaseUrl}?showOutbox=1${invalidateCache ? '&invalidateCache=true' : ''}`;
            },
            // Ordered list of folders without cache
            //GET /v2/mailbox/:email/folders/list
            getFoldersListNoCache() {
                return `${mapiBaseUrl}/list`;
            },
            // GET /v2/mailbox/:email/folders/recent
            hasRecentInFolders() {
                return `${mapiBaseUrl}/recent`;
            },
            send() {
                return `${baseUrl}/v2/message/send`;
            },
            sendStatus(uniqId) {
                return `${baseUrl}/v2/message/send/${uniqId}/status`;
            },
            // GET /v2/mailbox/:email/folders/:folder/messages (append /:msguid for single message)
            // limit: Int ?= 10, offset: Int ?= 0, query: Option[QueryParams] ?= None, peek: Boolean ?= false
            messages(folder, msguid) {
                const base = `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages`;
                return base + `${msguid ? `/${msguid}` : ''}`;
            },
            /* Messages thread */
            // GET /v2/mailbox/:email/folders/:folder/messages/:msguid/thread
            messagesThread(folder, msguid) {
                return `${mapiUrl}${userEmail}/messages?messageId=${msguid}`;
            },
            /* Disposition notification related */
            // POST /v2/mailbox/:email/folders/:folder/messages/:msguid/receipt/read
            readReceipt(folder, msguid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/receipt/read`;
            },
            /* Redirect (send an email skipping Sent folder) */
            // /v2/mailbox/:email/folders/:folder/messages/:msguid/redirect
            redirect(folder, msguid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/redirect`;
            },
            /* Mark as NOT spam */
            // POST /v2/mailbox/:email/folders/:folder/messages/:msguid/notSpam
            reportNotSpam(folder, msguid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/notSpam`;
            },
            /* Mark as spam */
            // POST /v2/mailbox/:email/folders/:folder/messages/:msguid/report
            reportSpam(folder, msguid) {
                return `${mapiBaseUrl}/${encodeURIComponent(folder)}/messages/${msguid}/report`;
            },
            /* Search */
            // POST /v2/mailbox/:email/search
            // query params: limit: Int ?= 10, offset: Int ?= 0
            search(args = {}) {
                const { offset, limit } = args;
                let queryString =  offset > 0 ? `?offset=${offset}` : '';
                queryString += limit > 0
                    ? `${queryString.length > 0 ? '&' : '?'}limit=${limit}`
                    : queryString;

                return `${mapiUrl}${userEmail}/search${queryString}`;
            },
            scheduled() {
                return `${baseUrl}/v2/message/send/schedule`;
            },
            cancelSchedule(messageId) {
                return `${baseUrl}/v2/message/send/schedule/${messageId}`;
            },
            reschedule(messageId) {
                return `${baseUrl}/v2/message/send/schedule/${messageId}`;
                //PUT            /v2/message/send/schedule/:messageId
                //
                // Body:
                // {
                //     "sendAt": 1234567890
                //     "newMessageId": 1234567890 //optional
                // }
            }
        };

    return {
        baseUrl,
        fetch: doAjax,
        methods: endPoints(version),
        // ...endPoints(version)
    };
};
